
import { Lightbulb } from 'lucide-react';
import { SmartSuggestions } from '@/components/ui/smart-suggestions';
import { useEnhancedSuggestions } from '@/hooks/use-enhanced-suggestions';
import { formatSuggestionTitle } from '@/utils/document-formatter';

export function SmartSuggestionsWrapper() {
  const { suggestions } = useEnhancedSuggestions();

  if (suggestions.length === 0) return null;

  const getActionRoute = (suggestionId: string): string => {
    // Convert suggestion IDs to appropriate routes
    if (suggestionId === 'complete-assessment') return '/business-assessment';
    if (suggestionId.startsWith('create-')) return '/documents';
    if (suggestionId.includes('analysis') || suggestionId.includes('forecast') || 
        suggestionId.includes('roadmap') || suggestionId.includes('strategy') || 
        suggestionId.includes('optimization')) return '/documents';
    return '/documents'; // Default fallback
  };

  const convertPriorityToNumber = (priority: 'high' | 'medium' | 'low'): number => {
    switch (priority) {
      case 'high': return 3;
      case 'medium': return 2;
      case 'low': return 1;
      default: return 2;
    }
  };

  // Transform enhanced suggestions to match SmartSuggestions component format
  const transformedSuggestions = suggestions.map(suggestion => ({
    id: suggestion.id,
    title: suggestion.title, // Already formatted by useEnhancedSuggestions
    description: suggestion.description,
    actionText: formatSuggestionTitle(suggestion.category),
    icon: '💡',
    action: getActionRoute(suggestion.id),
    priority: convertPriorityToNumber(suggestion.priority)
  }));

  const handleDismiss = (id: string) => {
    // For now, we'll just log the dismiss action
    // This can be enhanced later with actual persistence
    console.log('Dismissing suggestion:', id);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb className="h-5 w-5 text-yellow-500" />
        <h3 className="text-lg font-semibold text-gray-900">Smart Suggestions</h3>
      </div>
      <SmartSuggestions suggestions={transformedSuggestions} onDismiss={handleDismiss} />
    </div>
  );
}
